import { fontFamily } from '@/styles/typography';
import { useToken } from '@chakra-ui/react';
import styleguide from '@common/styleguide';
import { toPx } from '@common/util/styles';
import { getUuid } from '@common/util/uuid';
import { useEffect, useMemo, useState } from 'react';
import { TextInputProps } from './TextInput';
import { useVGSContext } from './VGSProvider';

type SsnInputProps = Omit<TextInputProps, 'onChange' | 'value'>;

function SsnInput({ placeholder }: SsnInputProps) {
    const { vgsForm } = useVGSContext();
    const [isInitialized, setIsInitialized] = useState(false);
    const fieldId = useMemo(() => 'ssn-field-' + getUuid(), []);

    // TODO: Update props to support more expressive theming, and more
    // consistency with other inputs.
    const [borderColor, focusColor] = useToken('colors', [
        'gray.300',
        'blue.500',
    ]);
    const height = 36;
    const width = 200;

    const css = {
        color: styleguide.semantic.textDark,
        fontSize: toPx(styleguide.typography.fontSizes.lgr),
        fontFamily: fontFamily.font,
        height: toPx(height),
        width: toPx(width),
        borderBottom: '1px solid ' + borderColor,
        '&:focus': {
            borderBottom: '2px solid ' + focusColor,
        },
        '&::placeholder': {
            color: borderColor,
        },
    };

    useEffect(() => {
        if (vgsForm && !isInitialized) {
            vgsForm.field('#' + fieldId, {
                name: 'ssn',
                type: 'ssn',
                placeholder,
                validations: ['required', 'validSSN'],
                css,
            });
            setIsInitialized(true);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [vgsForm, isInitialized]);

    return (
        <div
            style={{ maxHeight: toPx(height + 2), width, overflow: 'hidden' }}
            id={fieldId}
        />
    );
}

export default SsnInput;
